const getAppMetricsNavigatorPeriod = (metricsPeriodType, selectedPeriod) => {
  let chartMax, navigatorPeriod, firstRecordDay
  if (metricsPeriodType === 'MONTHLY') {
    const [year, month, firstRecord] = selectedPeriod.split('-')
    firstRecordDay = firstRecord
    const lastDayOfMonth = new Date(parseInt(year), parseInt(month), 0)
    chartMax = lastDayOfMonth.getDate()
    const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1)
    navigatorPeriod = `${capitalize(lastDayOfMonth.toLocaleString('pt-BR', { month: 'long' }))} de ${year}`
  } else {
    chartMax = 12
    navigatorPeriod = selectedPeriod
  }
  return { firstRecordDay, chartMax, navigatorPeriod }
}

export default getAppMetricsNavigatorPeriod
